import { createContext, FC, useContext, useRef, useState } from "react";
import { REPORT_FILTER_BY_OPTION_VALUES } from "../../../constants/constants";

const contextDefaultValue = {
  allGroupsSelected: false,
  setAllGroupsSelected: (allGroupsSelected: any) => {},
  selectedGroups: [] as string[],
  allAssetsSelected: false,
  setAllAssetsSelected: (allAssetsSelected: any) => {},
  groupSearchKeyword: "",
  setGroupSearchKeyword: (groupSearchKeyword: string) => {},
  assetSearchKeyword: "",
  setAssetSearchKeyword: (assetSearchKeyword: string) => {},
  selectedAssets: [] as string[],
  selectedDataType: REPORT_FILTER_BY_OPTION_VALUES.GROUP,
  setSelectedDataType: (selectedDataType: any) => {},
  setSelectedGroups: (selectedGroups: string[]) => {},
  setSelectedAssets: (selectedAssets: string[]) => {},
  onGroupSelectionConfirm: null as any,
};

const heatmapContext = createContext(contextDefaultValue);

export const HeatmapContextProvider: FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [allGroupsSelected, setAllGroupsSelected] = useState(true);
  const [allAssetsSelected, setAllAssetsSelected] = useState(true);
  const [groupSearchKeyword, setGroupSearchKeyword] = useState("");
  const [assetSearchKeyword, setAssetSearchKeyword] = useState("");
  const [selectedGroups, setSelectedGroups] = useState<string[]>([]);
  const [selectedAssets, setSelectedAssets] = useState<string[]>([]);
  const [selectedDataType, setSelectedDataType] = useState(
    REPORT_FILTER_BY_OPTION_VALUES.GROUP
  );
  const onGroupSelectionConfirm = useRef((values: any) => {});

  return (
    <heatmapContext.Provider
      value={{
        allGroupsSelected,
        setAllGroupsSelected,
        selectedGroups,
        setSelectedGroups,
        setSelectedAssets,
        onGroupSelectionConfirm,
        allAssetsSelected,
        setAllAssetsSelected,
        groupSearchKeyword,
        setGroupSearchKeyword,
        assetSearchKeyword,
        setAssetSearchKeyword,
        selectedAssets,
        setSelectedDataType,
        selectedDataType,
      }}
    >
      {children}
    </heatmapContext.Provider>
  );
};

export const useHeatmapContext = () => {
  const {
    allGroupsSelected,
    setAllGroupsSelected,
    selectedGroups,
    allAssetsSelected,
    setAllAssetsSelected,
    groupSearchKeyword,
    setGroupSearchKeyword,
    assetSearchKeyword,
    setAssetSearchKeyword,
    selectedAssets,
    setSelectedDataType,
    selectedDataType,
    setSelectedGroups,
    setSelectedAssets,
  } = useContext(heatmapContext);
  return {
    allGroupsSelected,
    setAllGroupsSelected,
    selectedGroups,
    allAssetsSelected,
    setAllAssetsSelected,
    groupSearchKeyword,
    setGroupSearchKeyword,
    assetSearchKeyword,
    setAssetSearchKeyword,
    selectedAssets,
    setSelectedDataType,
    selectedDataType,
    setSelectedGroups,
    setSelectedAssets,
  };
};
